import React from 'react';
import { FormattedMessage } from 'react-intl';

import { GenericNotification } from './GenericNotification';
import { NotificationType } from '../../../utils/hooks/useNotificator/useNotificator.types';

export const permanentDeleteErrorNotification =
  () =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={<FormattedMessage id="files-manager.delete-permanently-error-toast1" />}
        dataHook="permanent-delete-error-notification"
        type={NotificationType.Destructive}
      />
    );